import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getAccessTokenforResource, getDelegationTokenForOwa } from 'owa-tokenprovider';
import { getOrigin } from 'owa-url';

const IAPI_TOKEN_SCOPE: string = 'https://outlook.office.com/M365.Access';

export default function getTokenForImageApi(): Promise<string> {
    return isConsumer() ? getConsumerToken() : getAccessTokenforResource(getOrigin());
}

export function getConsumerToken(): Promise<string> {
    return getDelegationTokenForOwa(IAPI_TOKEN_SCOPE);
}
